import script from "./MyOrderTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyOrderTab.vue?vue&type=script&setup=true&lang=ts"

import "./MyOrderTab.vue?vue&type=style&index=0&id=8f31c34c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f31c34c"]])

export default __exports__